var map = {
	"./bug.svg": "c9c5",
	"./eggs.svg": "d1fa",
	"./fish.svg": "b402",
	"./grass.svg": "fb35",
	"./logo-curex.svg": "7f0a",
	"./milk.svg": "a8c7",
	"./molds.svg": "854b",
	"./nuts.svg": "ada2",
	"./paw.svg": "4332",
	"./plus.svg": "4eb1",
	"./pollen.svg": "dac7",
	"./preloaders/circle-preloader.svg": "929b",
	"./spectrum.svg": "c167",
	"./trees.svg": "4b61",
	"./wheat.svg": "e81b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";